import { useSelector } from 'react-redux';

import { sharedChannelsCartApi } from '@reducers/order';

export function configureSharedChannelsCartQueries() {
  const { login } = useSelector((state) => state.auth.user);
  const [addQuery, addResult] =
    sharedChannelsCartApi.useAddChannelToCartMutation();
  const [removeQuery, removeResult] =
    sharedChannelsCartApi.useRemoveChannelFromCartMutation();
  const [clearQuery, clearResult] =
    sharedChannelsCartApi.useClearChannelCartMutation();
  return {
    add: { query: (id) => addQuery({ id, login }), result: addResult },
    remove: {
      query: (id) => removeQuery({ id, login }),
      result: removeResult,
    },
    clear: { query: () => clearQuery({ login }), result: clearResult },
  };
}
